export default "__VITE_ASSET__Bp_prD0C__"